import { observer } from "mobx-react-lite"

import type { ILiquidityPool } from "@/domains/pools/types"
import { cn } from "@/domains/library"
import { DisplayTokens } from "@/domains/tokens/components/display-tokens"

/**
 * Wrapped in `observer` so callers that hand us a live pool store — e.g.
 * the CL pool-list row, the create-position sidebar — react when the pool's
 * `tokens`, `displayName`, or `displayType` settle after the indexer /
 * token repository populate. Previously this was a plain functional
 * component, which meant the first render captured whatever half-loaded
 * pool state existed and then froze, matching the "only one row shows
 * real data on beta" bug surface.
 */
export const DisplayLiquidityPool = observer(function DisplayLiquidityPool({
  pool,
  label = undefined,
  className,
  showLabel = true,
}: {
  pool: ILiquidityPool
  label?: string
  className?: string
  showLabel?: boolean
}) {
  const displayLabel = label ?? pool.displayType

  return (
    <div className={cn("flex flex-col items-center justify-start gap-2 whitespace-nowrap sm:flex-row", className)}>
      <DisplayTokens tokens={pool.tokens} tokenSize={38} />
      <div className="flex flex-col items-start">
        <div className="text-xs text-t100">{pool.displayName}</div>
        {showLabel ? <div className="text-xs text-t200">{displayLabel}</div> : null}
      </div>
    </div>
  )
})
